import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  ClientColShrink: {
    maxWidth: '300px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  paperStyleTwo: {
    backgroundColor: 'rgba(255,255,255,1)',
    padding: theme.spacing(2),
    border: '2px solid rgba(162,156,153,0.2)',
    borderRadius: '10px',
  },

  paperWhite: {
    backgroundColor: 'rgba(255,255,255,1)',
    padding: theme.spacing(4),
    border: '2px solid rgba(162,156,153,0.2)',
    borderRadius: '10px',
  },

  paperMessage: {
    backgroundColor: 'rgba(255,255,255,1)',
    padding: theme.spacing(1.5),
    border: '2px solid rgba(162,156,153,0.2)',
    borderRadius: '5px',
  },

  paperField: {
    border: '2px solid rgba(162,156,153,0.2)',
    boxShadow: 'none',
    borderRadius: 15,
    backgroundColor: 'rgba(255,255,255,0.8)',
    padding: '18px',
    minHeight: '60px',
  },

  paperHeadingPage: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(3),
    },
  },

  paperHeadingSection: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
    },
  },

  heading: {
    marginTop: theme.spacing(0.2),
    marginBottom: theme.spacing(0),
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },
  },
  subheading: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },

  selectcreatebtn: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    color: '#FF7412',
    padding: '10px 5px 10px 0px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#FF7412',
      boxShadow: 'none',
    },
  },

  waterMark: {
    paddingTop: '13%',
  },
  pagination: {
    float: 'none !important',
    overflowX: 'visible !important',
    display: 'flex',
    justifyContent: 'center',
  },
  paperWhiteTitle: {
    color: '#61B3CD !important',
    fontWeight: 'bold',
    paddingBottom: '10px',
  },
  addListNumber: {
    color: '#61B3CD',
  },
  addlistBg: {
    backgroundColor: 'rgba(162,156,153,0.2)',
    borderRadius: '5px',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  addListSpacing: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  backButton: {
    [theme.breakpoints.up('sm')]: {
      backgroundColor: 'white',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
  },
  hide: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    direction: 'column',
    justify: 'flex-start',
  },
  small: {
    width: 52,
    height: 52,
    backgroundColor: '#61B3CD !important',
  },
  large: {
    width: '100px !important',
    height: '100px !important',
    backgroundColor: '#61B3CD !important',
  },
  medium: {
    width: '70px !important',
    height: '70px !important',
    backgroundColor: '#61B3CD !important',
  },
  logout: {
    fontSize: 18,
    fontWeight: 700,
    padding: '5px 30px',
  },

  multilinestyle: {
    '& .MuiInputLabel-formControl': {
      marginLeft: theme.spacing(0),
      top: '-5px',
    },
    '& .MuiInputLabel-shrink': {
      top: '0',
    },
    '& .Mui-focused': {
      top: '0',
    },
    '& label + .MuiInput-formControl': {
      marginTop: '26px',
    },
  },

  disabledBg: {
    backgroundColor: 'rgba(227, 226, 225, 1)',
  },

  circleIconBox: {
    backgroundColor: '#ffffff',
    border: '4px solid rgba(243,239,234,1)',
    borderRadius: '100px',
    height: '130px',
    width: '130px',
    boxShadow: '0px 0px 10px #eae9e8',
    display: 'inline-flex',
    verticalAlign: 'middle',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButton: {
    right: '8px',
    top: '8px',
    textAlign: 'right',
  },

  tbAlert: {
    fontSize: '12px',
    backgroundColor: '#61B3CD',
    color: '#ffffff',
    borderRadius: '5px',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },

  EmployeeDirectoryTable: {
    '& .MuiTableRow-head': {
      '& .MuiTableCell-root:nth-child(1)': {
        width: '20% !important', // Employee Name - increased for names + checkboxes
      },
      '& .MuiTableCell-root:nth-child(2)': {
        width: '10% !important', // Country
      },
      '& .MuiTableCell-root:nth-child(3)': {
        width: '8% !important', // Cell - slightly increased
      },
      '& .MuiTableCell-root:nth-child(4)': {
        width: '15% !important', // Department - increased
      },
      '& .MuiTableCell-root:nth-child(5)': {
        width: '15% !important', // My Supervisor - increased
      },
      '& .MuiTableCell-root:nth-child(6)': {
        width: '18% !important', // Email - increased for email addresses
      },
      '& .MuiTableCell-root:nth-child(7)': {
        width: '12% !important', // Phone Number - REDUCED from 32% to 12%
      },
      '& .MuiTableCell-root:nth-child(8)': {
        width: '10% !important', // Account Status
      },
      '& .MuiTableCell-root:nth-child(9)': {
        width: '5% !important', // Edit
        textAlign: 'center',
      },
      '& .MuiTableCell-root:nth-child(10)': {
        width: '5% !important', // Delete
        textAlign: 'center',
      },
      '& .MuiTableCell-root:nth-child(11)': {
        width: '10% !important', // Share Form
        textAlign: 'center',
      },
    },

    '& .MuiTableRow-root': {
      '& .MuiTableCell-body:nth-child(1)': {
        '& a': {
          textDecoration: 'underline',
        },
      },
      '& .MuiTableCell-body:nth-child(2)': {
        width: 'auto !important',
        wordBreak: 'normal !important',
      },
      '& .MuiTableCell-body:nth-child(7)': {
        // Phone Number column - ensure proper text wrapping
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      '& .MuiTableCell-body:nth-child(8)': {
        textAlign: 'center', // Account Status
      },
      '& .MuiTableCell-body:nth-child(9)': {
        textAlign: 'center', // Edit
      },
      '& .MuiTableCell-body:nth-child(10)': {
        textAlign: 'center', // Delete
      },
      '& .MuiTableCell-body:nth-child(11)': {
        textAlign: 'center', // Share Form
      },
    },
  },

  AccountDirectoryDetailTable: {
    '& .MuiTableRow-root': {
      '& .MuiTableCell-body:nth-child(2)': {
        textDecoration: 'underline',
      },
    },
  },

  actions: {
    display: 'block !important',
    textAlign: 'center',
  },

  materialHighlight: {
    backgroundColor: '#e2ddd8',
  },
  chat: {
    Position: 'relative',
    height: '450px',
    overflowY: 'scroll',
  },

  chatLeft: {
    textAlign: 'left',
  },
  chatCenter: {
    textAlign: 'center',
  },
  chatRight: {
    textAlign: 'right',
  },

  chatLeftBox: {
    backgroundColor: 'rgba(255,255,255,1)',
    padding: theme.spacing(2),
    borderTopRightRadius: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    fontSize: '16px',
    color: '#4B403A',
    display: 'inline-flex',
    boxShadow: '0px 2px 2px rgba(29,25,23,0.09)',
    marginTop: '5px',
    marginBottom: '10px',
  },

  chatRightBox: {
    backgroundColor: 'rgba(127,193,214,1)',
    padding: theme.spacing(2),
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    fontSize: '16px',
    color: '#ffffff',
    boxShadow: '0px 2px 2px rgba(29,25,23,0.09)',
    marginTop: '5px',
    marginBottom: '10px',
    display: 'inline-flex',
    textAlign: 'left',
  },

  chatProW: {
    width: '80px',
    flex: 'inherit',
  },

  profileW: {
    width: '150px !important',
    flex: 'inherit !important',
  },

  selectderror: {
    color: '#f44336',
    marginLeft: '12px',
    marginRight: '12px',
  },

  selectedTags: {
    color: '#4B403A',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    margin: '10px 5px 0px 5px',
  },

  responsedropzonestyle: {
    '& .makeStyles-dropzonestyle-101': {
      padding: '20px',
      '& .makeStyles-dropzonetitle-102': {
        display: 'flex',
        '& .makeStyles-dropzonetext-103': {
          width: '140px',
          lineHeight: '16px',
        },
      },
    },
  },

  warning: {
    border: '2px solid rgba(162,156,153,0.2)',
    borderRadius: '5px',
    backgroundColor: '#61B3CD',
    '& .MuiTypography-h3': {
      color: '#fff',
    },
  },
  warningicon: {
    display: 'flex',
    backgroundColor: '#fff',
    color: '#FF7412',
    borderRadius: '50%',
    padding: '5px',
  },
  whitebutton: {
    backgroundColor: '#fff',
    color: '#FF7412',
    '&:hover': {
      backgroundColor: '#fff',
    },
  },

  container1: {
    display: 'flex',
    padding: '10px 20px',
    backgroundColor: '#fff',
    maxWidth: '600px',
    margin: '12px auto',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '20px',
    border: '1px solid #ddd',
  },

  content: {
    display: 'flex',
    alignItems: 'center',
  },

  btn: {
    color: '#fff',
    textAlign: 'center',
    width: '30px',
    height: '40px',
    lineHeight: '40px',
    border: 'none',
  },

  resourceItem: {
    '& img': {
      boxShadow: '0 2px 10px 0 rgb(0 0 0 / 15%)',
      marginBottom: theme.spacing(4),
    },
    '& video': {
      boxShadow: '0 2px 10px 0 rgb(0 0 0 / 15%)',
      marginBottom: theme.spacing(4),
    },
    '& iframe': {
      boxShadow: '0 2px 10px 0 rgb(0 0 0 / 15%)',
      marginBottom: theme.spacing(2),
    },
  },
  innercontentWidth: {
    maxWidth: 'calc(50% - 8px)',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  innercontent: {
    backgroundColor: '#e5ebf1',
    borderRadius: '4px',
  },
  innercontentWhite: {
    backgroundColor: '#fff',
    borderRadius: '4px',
    padding: 16,
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  clearbtn: {
    fontSize: 11,
    cursor: 'pointer',
    minWidth: 'auto !important',
    fontWeight: '400 !important',
    '&:hover': {
      background: 'none !important',
    },
  },
  hideChart: {
    display: 'none',
  },
  dialogOuterMedium: {
    '& .MuiDialogActions-spacing': {
      justifyContent: 'flex-end',
      '@media (max-width:414px)': {
        justifyContent: 'center',
      },
      '& div': {
        margin: '0',
      },
    },
    '& .MuiAutocomplete-inputRoot': {
      padding: '0 !important',
    },
  },
  trainingResourcesDialog: {
    '& .MuiDialog-paper': {
      width: '500px',
      maxWidth: '500px',
      '@media (max-width:600px)': {
        width: '90vw',
        maxWidth: '90vw',
      },
    },
    '& .MuiDialogActions-spacing': {
      justifyContent: 'flex-end',
      '@media (max-width:414px)': {
        justifyContent: 'center',
      },
      '& div': {
        margin: '0',
      },
    },
    '& .MuiAutocomplete-inputRoot': {
      padding: '0 !important',
    },
  },
  dialogTitle: {
    '& .MuiTypography-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '@media (max-width:768px)': {
        textAlign: 'left',
        whiteSpace: 'normal',
      },
    },
    '& .dialogTitleDashboard': { padding: '16px 16px 0 !important' },
  },
  dialogTitleDashboard: {
    '& .MuiTypography-root ': {
      padding: '16px 16px 0 !important',
    },
  },
  ExpandBlock: {
    width: '100%',
    '& .MuiAccordion-root.Mui-expanded': {
      marginTop: '16px !important',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '0 !important',
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: 'auto',
    },
    '& .MuiAccordionDetails-root': {
      paddingTop: 0,
      flexWrap: 'wrap',
    },
  },
  DashboardExpandBlock: {
    width: '100%',
    '& .MuiAccordion-root': {
      marginTop: '0',
      background: '#fff',
      boxShadow: '0px 2px 3px rgb(0 0 0 / 10%)',
      '&:last-child': {
        marginBottom: '0',
      },
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '48px',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '0',
    },
  },
  PerformanceNotesProfile: {
    height: '44px',
    width: '44px',
    borderRadius: '5px',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  },
  PerformanceNotesProfileBig: {
    height: '90px',
    width: '90px',
    borderRadius: '5px',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  },
  TabBlock: {
    padding: '0 16px',
    '& .MuiAppBar-colorPrimary': {
      backgroundColor: '#fff',
      boxShadow: 'none',
    },
    '& .MuiTab-textColorInherit.Mui-selected': {
      color: '#000',
    },
  },
  RadioStyle: {
    '& .MuiRadio-root': {
      color: '#92979d',
    },
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: '#FF3E32',
    },
  },
  GlobalGivingCausesLink: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  GlobalGivingCausesLinkAR: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    color: '#4e5054',
    borderBottom: '1px solid #4e5054',
    fontWeight: '700',
  },
  TableLink: {
    color: '#4e5054 !important',
    borderBottom: '1px solid #4B403A',
    fontWeight: '700',
    cursor: 'pointer',
  },
  GlobalGivingCausesThumb: {
    width: '100%',
    height: '200px',
    objectFit: 'contain',
  },
  GlobalGivingCausesMore: {
    marginTop: '-10px',
    '& svg': {
      color: '#92979d',
      fontSize: '30px',
    },
  },
  GlobalGivingCausesTextBox: {
    height: '60px',
  },
  GlobalGivingCausesText: {
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  helperText: {
    '& p.Mui-error': {
      marginLeft: '1.5px !important',
    },
  },
  wrapper: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4),
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  dateRangePickerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 99999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& hr+div>div:last-child': {
      display: 'none',
    },
    '& > div': {
      position: 'relative',
      zIndex: 100000,
      width: 'auto',
      maxWidth: '90vw',
      maxHeight: '90vh',
    },
    '& > div > div:first-child': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99998,
    },
    '& > div > div:last-child': {
      position: 'relative',
      zIndex: 99999,
      backgroundColor: '#fff',
      borderRadius: '4px',
      boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
    },
    '& .MuiSvgIcon-root': { color: '#003c6f' },
    '& .MuiSvgIcon-colorDisabled': { color: 'rgba(0, 0, 0, 0.26)' },
    '& .MuiInputBase-input': {
      padding: '5px 30px 0px 10px',
      borderRadius: 0,
      boxShadow: 'none',
    },
    '& .MuiGrid-wrap-xs-nowrap': {
      '@media (max-width:768px)': {
        flexWrap: 'wrap',
        justifyContent: 'center',
      },
    },
    '& .MuiList-padding': {
      '@media (max-width:768px)': {
        flexWrap: 'wrap',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
      },
    },
    '& .MuiListItem-button': {
      '@media (max-width:768px)': {
        width: 'auto',
      },
    },
    '& [class*="makeStyles-header-"]': {
      padding: '20px 50px',
      '@media (max-width:768px)': {
        padding: '10px 20px',
      },
    },
    '& [class*="makeStyles-headerItem-"]': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& .materialui-daterange-picker-makeStyles-divider-6': {
      '@media (max-width:768px)': {
        display: 'none',
      },
    },
  },
  ViewAll: {
    marginLeft: '5px',
    marginTop: '3px',
    cursor: 'pointer',
    '& svg': {
      color: '#92979d',
      fontSize: '20px',
    },
  },
  ViewAllText: {
    cursor: 'pointer',
  },
  MoreOptions: {
    '& .MuiList-root': {
      margin: 0,
    },
    '& .MuiListItem-button': {
      '&:hover': {
        backgroundColor: '#809db7',
        color: '#fff',
      },
    },
  },
  MoreOptionsIcon: {
    cursor: 'pointer',
    color: '#92979d',
  },
  PositionRelative: {
    position: 'relative',
  },
  PerformanceNotesMoreIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  FileUploadStyle: {
    position: 'relative',
    '& .MuiOutlinedInput-input': {
      opacity: 0,
    },
  },
  AddIcon: {
    position: 'absolute',
    margin: 'auto',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    color: '#92979d',
  },
  Button: {
    background: '#e5ebf1 !important',
    color: '#003c6f !important',
    border: '2px solid #809db7 !important',
    boxShadow: 'none !important',
    padding: '0px 0px !important',
    fontWeight: '400',
    '&:hover': {
      background: '#e5ebf1 !important',
      color: '#003c6f !important',
      border: '2px solid #809db7 !important',
      boxShadow: 'none !important',
      padding: '0px 0px !important',
    },
    '@media (max-width:768px)': {
      minWidth: '35px !important',
      '& span': {
        '& span': {
          display: 'none !important',
        },
      },
    },
  },
  EditOptionsIcon: {
    color: '#92979d',
    cursor: 'pointer',
  },
  EditOptionsList: {
    color: '#4e5054',
    fontSize: '13px',
    padding: '6px 16px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#809db7',
      color: '#fff',
    },
  },
  MaterialDTStyle: {
    '& thead': {
      display: 'none',
    },
  },
  secondaryBtnUI: {
    minWidth: '120px !important',
  },
  AutoCompleteDisable: {
    '& .MuiAutocomplete-inputRoot.Mui-disabled': {
      padding: '0 !important',
      '& input': {
        borderRadius: 7,
      },
    },
  },
  AddNoteDailog: {
    '& .MuiDialog-paperWidthSm': {
      width: '500px',
    },
  },
  LearningOpportunitiesDetails: {
    '& .MuiPaper-root': {
      backgroundColor: 'transparent',
    },
    '& .MuiTableHead-root': {
      display: 'none',
    },
    '& .MuiTableCell-root': {
      border: 'none',
    },
    '& .MuiTableCell-root:last-child': {
      width: '100% !important',
      paddingRight: '0 !important',
    },
    '& .MuiTableRow-root': {
      background: 'transparent',
    },
    '& .MuiTableRow-root:hover': {
      background: 'transparent',
    },
    '& .MuiTablePagination-root': {
      boxShadow: '0px 2px 3px rgb(0 0 0 / 10%)',
      borderRadius: '4px',
      backgroundColor: '#fff',
      border: 'none',
    },
  },

  flexBoxContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  mtAuto: {
    marginTop: 'auto',
  },

  MTable: {
    '& table': {
      minWidth: 650,
      '@media (max-width:768px)': {
        minWidth: '100%',
      },
    },
    '& th span': {
      padding: '0',
      color: '#616569',
      fontSize: '14px !important',
      fontWeight: 400,
      backgroundColor: '#e1e4e8 !important',
      width: 'auto !important',
    },
    '& th': {
      borderBottom: '1px solid #616569',
      backgroundColor: '#e1e4e8 !important',
    },
    '& th,& td': {
      padding: '6px 24px 6px 16px',
      color: '#616569',
      fontSize: '14px !important',
      fontWeight: 400,
      whiteSpace: 'nowrap',
    },
  },
  MTablePagination: {
    backgroundColor: '#fff !important',
    color: '#616569',
    fontSize: '14px !important',
    fontWeight: 400,
    alignItems: 'center',
    '& button': {
      borderRadius: 3,
      backgroundColor: '#fff !important',
      color: '#868787',
      padding: 0,
      minWidth: 32,
      minHeight: 32,
      border: '1px solid #dee6ec',
      marginRight: 10,
      marginTop: 0,
    },
    '& button:disabled': {
      backgroundColor: '#fff !important',
      color: '#003C6F',
    },
  },
  MTablePaginationText: {
    padding: '8px 15px',
    color: '#868787',
    fontSize: '12px',
  },
  MTableRightContent: {
    textAlign: 'right',
    padding: '8px',
  },
  AccountDirectoryTable: {
    '& .MuiTableCell-root:last-child': {
      textAlign: 'right',
      width: 'inherit !important',
    },
    '& .MuiTableSortLabel-icon': {
      //display: 'none',
    },
    '& .MuiTableRow-root': {
      '& .MuiTableCell-body:nth-child(1) a': {
        textDecoration: 'underline',
      },
      '& .MuiTableCell-body:nth-child(2)': {
        width: 'calc(10% - 8px) !important',
      },
      '& .MuiTableCell-body:nth-child(3)': {
        width: 'calc(10% - 8px) !important',
      },
    },
  },
  TableTotalUI: {
    '& .MuiTable-root': {
      display: 'block',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    },
    '& .MuiTableRow-root:last-child': {
      '& .MuiTableCell-root': {
        fontWeight: 'bold !important',
      },
    },
    '& .MuiTableCell-head': {
      whiteSpace: 'normal',
      lineHeight: '16px',
      '& span': {
        minWidth: '90px',
        display: 'flex',
      },
    },
    '& .MuiTableCell-head:nth-child(1)': {
      zIndex: '3 !important',
      left: '0px !important',
    },
    '& .MuiTableCell-head:nth-child(2)': {
      background: '#cae7da !important',
    },
    '& .MuiTableCell-head:nth-child(3)': {
      background: '#fdebeb !important',
    },
    '& .MuiTableCell-head:nth-child(4)': {
      background: '#fdd7d6 !important',
    },
    '& .MuiTableCell-head:nth-child(5)': {
      background: '#fec5c2 !important',
    },
    '& .MuiTableCell-head:nth-child(6)': {
      background: '#feb1ad !important',
    },
    '& .MuiTableCell-head:nth-child(7)': {
      background: '#fe9e98 !important',
    },
    '& .MuiTableCell-head:nth-child(8)': {
      background: '#fe8b84 !important',
    },
    '& .MuiTableCell-head:nth-child(9)': {
      background: '#fe7870 !important',
    },
    '& .MuiTableCell-root:first-child': {
      textAlign: 'left',
    },
    '& .MuiTableCell-root': {
      width: '10% !important',
    },
  },

  TableTotalUIAll: {
    '& .MuiTable-root': {
      display: 'block',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    },

    // Mobile responsiveness
    '@media (max-width:768px)': {
      '& .MuiPaper-root': {
        margin: '0 -16px', // Extend to screen edges on mobile
        borderRadius: '0',
      },
    },
    '& .MuiTableCell-head': {
      whiteSpace: 'normal',
      lineHeight: '16px',
      '& span': {
        minWidth: 'calc(100% - 24px)',
        justifyContent: 'center',
        display: 'flex',
      },
    },
    '& .MuiTableCell-head:nth-child(2)': {
      background: '#cae7da !important',
    },
    '& .MuiTableCell-head:nth-child(3)': {
      background: '#fdebeb !important',
    },
    '& .MuiTableCell-head:nth-child(4)': {
      background: '#fdd7d6 !important',
    },
    '& .MuiTableCell-head:nth-child(5)': {
      background: '#fec5c2 !important',
    },
    '& .MuiTableCell-head:nth-child(6)': {
      background: '#feb1ad !important',
    },
    '& .MuiTableCell-head:nth-child(7)': {
      background: '#fe9e98 !important',
    },
    '& .MuiTableCell-head:nth-child(8)': {
      background: '#fe8b84 !important',
    },
    '& .MuiTableCell-head:nth-child(9)': {
      background: '#fe7870 !important',
    },
    '& .MuiTableCell-root:first-child': {
      textAlign: 'left',
    },
    '& .MuiTableCell-root': {
      width: '10% !important',
    },
    '& .MuiTableCell-head:nth-child(1)': {
      zIndex: '3 !important',
      left: '0px !important',
    },
    '& .MuiTablePagination-root': {
      width: '100% !important',
    },
  },

  SpanningTable: {
    '& .MuiTable-root': {
      display: 'block',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '& .MuiTableCell-root': {
          fontWeight: '400 !important',
        },
      },
      '& .MuiTableRow-root:last-child': {
        '& .MuiTableCell-root': {
          fontWeight: '700 !important',
        },
      },
    },
    '& .MuiTableCell-head': {
      whiteSpace: 'normal',
      lineHeight: '16px',
      background: 'none !important',
    },
    '& .MuiTableHead-root': {
      '& .MuiTableRow-head:first-child': {
        '& .MuiTableCell-head:nth-child(1)': {
          background: '#fff !important',
        },
        '& .MuiTableCell-head:nth-child(2)': {
          background: '#fff !important',
        },
        '& .MuiTableCell-head:nth-child(3)': {
          background: '#e5ebf0 !important',
        },
      },
      '& .MuiTableRow-head:first-child:hover': {
        background: 'none !important',
        cursor: 'default',
      },
      '& .MuiTableRow-head:last-child': {
        '& .MuiTableCell-head:nth-child(1)': {
          background: '#e5ebf0 !important',
        },
        '& .MuiTableCell-head:nth-child(2)': {
          background: '#cae7da !important',
        },
        '& .MuiTableCell-head:nth-child(3)': {
          background: '#fdebeb !important',
        },
        '& .MuiTableCell-head:nth-child(4)': {
          background: '#fdd7d6 !important',
        },
        '& .MuiTableCell-head:nth-child(5)': {
          background: '#fec5c2 !important',
        },
        '& .MuiTableCell-head:nth-child(6)': {
          background: '#feb1ad !important',
        },
        '& .MuiTableCell-head:nth-child(7)': {
          background: '#fe9e98 !important',
        },
        '& .MuiTableCell-head:nth-child(8)': {
          background: '#fe8b84 !important',
        },
        '& .MuiTableCell-head:nth-child(9)': {
          background: '#fe7870 !important',
        },
        '& .MuiTableCell-head:nth-child(10)': {
          background: '#e5ebf0 !important',
        },
        '& .MuiTableCell-head:nth-child(11)': {
          background: '#e5ebf0 !important',
        },
        '& .MuiTableCell-root:first-child': {
          textAlign: 'left',
        },
      },
    },

    '& .MuiTableCell-root': {
      width: '10% !important',
    },
  },
  Link: {
    textDecoration: 'none !important',
    borderBottom: '1px solid #003C6F',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none !important',
    },
  },
  AnnouncementTabBlock: {
    '& .MuiTab-root': {
      marginRight: '40px',
    },
  },
  FormDetailTopSection: {
    padding: '32px 24px',
    background: '#FFFFFF',
    borderTop: '8px solid #003C6F',
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    width: '760px',
    margin: '0 auto',
  },
  FormDetailBottomSection: {
    width: '760px',
    margin: '40px auto 0',
    '& .MuiStepper-root': {
      alignItems: 'flex-start',
      flexDirection: 'column',
      padding: '0',
    },
    '& .MuiStepLabel-root': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '& .MuiStepLabel-label.MuiStepLabel-active': {
      boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
      borderWidth: '8px 0px 0px 4px',
      borderStyle: 'solid',
      borderColor: '#003C6F',
      borderRadius: '0px 4px 4px 4px',
      padding: '16px',
      fontSize: '20px',
      fontWeight: '700',
    },
    '& .MuiFormControlLabel-label': {
      fontWeight: '700',
    },
    '& .MuiStep-horizontal': {
      padding: 0,
      width: '100%',
    },
  },
  FormDetailModal: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '900px',
    },
  },
  FormDetailModalSection: {
    width: '760px',
    margin: '0 auto',
    '& .MuiStepper-root': {
      alignItems: 'flex-start',
      flexDirection: 'column',
      padding: '0',
    },
    '& .MuiStepLabel-root': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '& .MuiStepLabel-label.MuiStepLabel-active': {
      boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
      borderWidth: '8px 0px 0px 4px',
      borderStyle: 'solid',
      borderColor: '#003C6F',
      borderRadius: '0px 4px 4px 4px',
      padding: '10px',
      fontSize: '20px',
      fontWeight: '700',
    },
    '& .MuiFormControlLabel-label': {
      fontWeight: '700',
    },
    '& .MuiStep-horizontal': {
      padding: 0,
      width: '100%',
    },
    '& .MuiStepLabel-iconContainer': {
      display: 'none',
    },
  },
  FormDetailSetps: {
    display: 'inline-flex',
    background: '#003c6f',
    color: '#fff',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '700',
    borderRadius: '5px 5px 0 0',
  },
  CardStyle: {
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
    borderRadius: '4px',
  },
  TabsDesktop: {
    display: 'block',
    '@media (max-width:768px)': {
      display: 'none',
    },
  },
  TabsMobile: {
    display: 'none',
    '@media (max-width:768px)': {
      display: 'block',
      '& .MuiSelect-select': {
        borderRadius: '4px',
        boxShadow: 'none',
        padding: '11.5px 14px',
        border: '1px solid #dee6ec',
      },
      '& .MuiSelect-icon': {
        color: '#003C6F',
      },
    },
  },
  FilterButtonMobile: {
    display: 'none',
    '@media (max-width:768px)': {
      display: 'block',
      '& .MuiButton-textPrimary': {
        minWidth: '100px',
        border: '1px solid #f0f2f3',
        borderRadius: '8px',
        color: '#4e5054',
        backgroundColor: '#fff',
        fontSize: '13px',
      },
    },
  },

  // Mobile-responsive styles for Clients Profit Chart
  ClientsProfitChartMobile: {
    '@media (max-width:768px)': {
      // Ensure chart container is properly sized on mobile
      '& .highcharts-container': {
        width: '100% !important',
        height: 'auto !important',
      },

      // Optimize chart spacing on mobile
      '& .highcharts-root': {
        fontSize: '10px !important',
      },

      // Ensure proper text rendering on mobile
      '& .highcharts-axis-labels text': {
        fontSize: '10px !important',
      },

      // Mobile-specific legend adjustments
      '& .highcharts-legend': {
        fontSize: '10px !important',
      },

      // Tooltip optimizations for mobile
      '& .highcharts-tooltip': {
        fontSize: '11px !important',
        padding: '6px !important',
      },
    },

    // Tablet adjustments
    '@media (max-width:1024px) and (min-width:769px)': {
      '& .highcharts-axis-labels text': {
        fontSize: '11px !important',
      },

      '& .highcharts-legend': {
        fontSize: '11px !important',
      },
    },
  },

  // Mobile-responsive styles for Collection Report Table
  CollectionsReportTableMobile: {
    '@media (max-width:768px)': {
      '& .MuiPaper-root': {
        overflowX: 'auto',
        width: '100%',
      },

      '& .MuiTable-root': {
        minWidth: '1200px', // Ensure table has minimum width for horizontal scroll
        width: 'auto',
      },

      '& .MuiTableCell-head': {
        fontSize: '12px !important',
        padding: '6px 8px !important',
        whiteSpace: 'nowrap',
        minWidth: '100px',
      },

      '& .MuiTableCell-body': {
        fontSize: '11px !important',
        padding: '6px 8px !important',
        whiteSpace: 'nowrap',
        minWidth: '100px',
      },

      // First column (Client) should be sticky on mobile
      '& .MuiTableCell-body:first-child, & .MuiTableCell-head:first-child': {
        position: 'sticky',
        left: 0,
        backgroundColor: '#ffffff',
        zIndex: 1,
        minWidth: '150px',
        maxWidth: '150px',
        boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
      },

      // Pagination adjustments for mobile
      '& .MuiTablePagination-root': {
        fontSize: '12px !important',
        '& .MuiTablePagination-selectIcon': {
          fontSize: '16px !important',
        },
        '& .MuiTablePagination-select': {
          fontSize: '12px !important',
        },
        '& .MuiTablePagination-caption': {
          fontSize: '12px !important',
        },
      },

      // Mobile toolbar adjustments
      '& .MuiToolbar-root': {
        minHeight: '48px !important',
        padding: '0 8px !important',
      },
    },

    // Tablet adjustments
    '@media (max-width:1024px) and (min-width:769px)': {
      '& .MuiTableCell-head': {
        fontSize: '13px !important',
        padding: '8px 10px !important',
      },

      '& .MuiTableCell-body': {
        fontSize: '12px !important',
        padding: '8px 10px !important',
      },
    },
  },
  FilterDesktop: {
    '& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      paddingRight: '65px !important',
    },
    '@media (max-width:768px)': {
      display: 'none',
    },
  },

  /* Table CSS */
  MonthsWorkedTableDetails: {
    maxHeight: '98vh',
    overflow: 'auto',
    '& .MuiTableCell-root:last-child': {
      width: 'auto !important',
    },
    '& .MuiTable-root': {
      tableLayout: 'fixed',
      whiteSpace: 'nowrap',
      borderCollapse: 'separate',
    },
    '& .MuiTableHead-root th': {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      textAlign: 'center',
      background: '#fff',
      '&:first-child': {
        width: '350px',
        position: 'sticky',
        left: 0,
        zIndex: 2,
        textAlign: 'left',
      },
    },
    '& .MuiTableBody-root th': {
      position: 'relative',
      background: '#fff',
      borderBottom: '2px solid #f3efea',
      padding: '12px',
      '&:first-child': {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        background: '#fff',
        textAlign: 'left',
        whiteSpace: 'break-spaces',
      },
    },
    '& .MuiTableBody-root td': {
      borderBottom: '2px solid #f3efea',
      background: '#fff',
      padding: '12px',
      textAlign: 'center',
    },
  },
  MonthsWorkedTableWrapper: {
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    },
  },
  MonthsWorkedTableOuter: {
    position: 'relative',
    display: 'block',
    width: '100%',

    '& table': {
      minWidth: '100%',
      borderCollapse: 'separate',
      borderSpacing: '0',
      '& td': {
        margin: '0',
        whiteSpace: 'nowrap',
        borderTopWidth: '0px',
        color: '#4e5054',
        fontSize: '13px',
        fontWeight: '400',
        padding: '12px 6px',
        borderBottom: '1px solid #dee6ec',
        borderRight: '1px solid #dee6ec',
        textAlign: 'center',
        minWidth: '10em',
      },
      '& th': {
        margin: '0',
        whiteSpace: 'nowrap',
        borderTopWidth: '0px',
        color: '#4e5054',
        fontSize: '13px',
        fontWeight: '400',
        padding: '12px',
        borderBottom: '1px solid #dee6ec',
        borderLeft: '1px solid #dee6ec',
        borderRight: '1px solid #dee6ec',
        textAlign: 'left',
      },
    },
  },
  MonthsWorkedTable: {
    overflowX: 'scroll',
    marginLeft: '30em',
    marginRight: '9em',
    '@media (max-width:768px)': {
      marginLeft: '28em',
      marginRight: '10em',
    },
    '@media (max-width:560px)': {
      marginLeft: 'inherit',
      marginRight: 'inherit',
    },
    overflowY: 'visible',
    padding: '0',
    display: 'block',
    '& tr:nth-child(2)': {
      '& th': {
        background: '#f2f5f8',
        fontSize: '13px',
      },
      '& td': {
        background: '#f2f5f8',
        fontSize: '13px',
      },
    },
    '& tr:last-child': {
      '& th': {
        border: 'none',
      },
      '& td': {
        border: 'none',
        background: '#fff',
        fontWeight: '400 !important',
        fontSize: '13px !important',
      },
    },
  },
  MonthsWorkedTableHead: {
    '& td': {
      fontWeight: '400 !important',
      backgroundColor: '#fff',
      fontSize: '13px !important',
      borderLeft: 'none',
      borderRight: 'none !important',
      '&:first-child': {
        textAlign: 'left',
        width: '30em',
      },
      '&:last-child': {
        fontWeight: '700 !important',
      },
    },
  },
  colleft: {
    position: 'absolute',
    width: '30em',
    '@media (max-width:768px)': {
      width: '28em',
    },
    '@media (max-width:560px)': {
      position: 'inherit',
    },
    left: '0',
    top: 'auto',
    borderTopWidth: '2px',
    marginTop: '-1px',
    borderLeft: '1px solid #dee6ec',
  },
  fontweightlight: {
    fontWeight: 400,
  },
  colright: {
    position: 'absolute',
    '@media (max-width:560px)': {
      position: 'inherit',
    },
    width: '10em',
    right: '0',
    top: 'auto',
    borderTopWidth: '2px',
    marginTop: '-1px',
    background: '#f2f5f8',
    fontWeight: '800 !important',
    borderRight: '1px solid #dee6ec',
    borderLeft: '1px solid #dee6ec',
  },
  colmiddlebg: {
    background: '#f2f5f8',
  },
  classPendingApproval: {
    color: 'red !important',
  },
  PendingApprovalLegend: {
    color: 'red !important',
    textAlign: 'left',
    marginBottom: '15px',
    '& a': {
      color: 'red !important',
      textDecoration: 'underline',
    },
  },
  MonthsWorkedTableBottom: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    '& table': {
      minWidth: '1000px',
      borderCollapse: 'separate',
      borderSpacing: '0',
      '& td': {
        margin: '0',
        whiteSpace: 'nowrap',
        borderTopWidth: '0px',
        color: '#4e5054',
        fontSize: '13px',
        fontWeight: '400',
        padding: '12px',
        borderBottom: '1px solid #dee6ec',
        textAlign: 'left',
      },
    },
  },
  AverageTotalDetail: {
    border: '1px solid #dee6ec',
  },
  ScoringTablePoints: {
    '& .MuiTypography-body1': {
      fontSize: '14px',
      color: '#003c6f',
      marginBottom: '8px',
      '& span': {
        fontWeight: '700',
      },
    },
  },
  divider: {
    '& .MuiDivider-root': {
      background: '#e5ebf0',
    },
  },
  AverageScorebyCategoryTable: {
    '& .MuiTableCell-body': {
      fontWeight: '700 !important',
      fontSize: '16px !important',
      color: 'rgba(15, 15, 16, 0.96) !important',
    },
    '& .MuiTableCell-alignLeft': {
      textAlign: 'center',
    },
  },
  TitleNumberBig: {
    fontWeight: '700',
    fontSize: '16px',
    color: 'rgba(15, 15, 16, 0.96)',
  },
  TitleNumberSmall: {
    fontWeight: '400',
    fontSize: '11px',
    color: 'rgba(15, 15, 16, 0.96)',
  },
  ScoringTable: {
    '& .MuiTableCell-head:nth-child(n+2):nth-child(-n+5)': {
      width: '10% !important',
      textAlign: 'center',
    },
    '& .MuiTableCell-head:nth-child(6)': {
      width: '10% !important',
      textAlign: 'center',
      fontSize: '15px',
      fontWeight: '900',
    },
    '& .MuiTableCell-body:nth-child(1)': {
      fontSize: '13px !important',
      fontWeight: '400 !important',
    },
    '& .MuiTableCell-body:nth-child(n+2):nth-child(-n+5)': {
      fontSize: '15px !important',
      fontWeight: '400 !important',
      textAlign: 'center',
    },
    '& .MuiTableCell-body:last-child': {
      fontSize: '15px !important',
      fontWeight: '900 !important',
      textAlign: 'center',
    },
    '& .MuiTableRow-root:last-child': {
      '& .MuiTableCell-body': {
        fontWeight: '900 !important',
      },
      '& .MuiTableCell-body:nth-child(1)': {
        fontSize: '15px !important',
        textAlign: 'right !important',
      },
      '& .MuiTableCell-body:last-child': {
        backgroundColor: '#e5ebf0 !important',
      },
    },
  },

  AdditionalCommentsBox: {
    '& .MuiTypography-h6': {
      fontSize: '13px',
      color: '#000',
    },
    '& .MuiTypography-body1': {
      backgroundColor: '#e5ebf0',
      fontWeight: '400',
      fontSize: '13px',
      padding: '8px',
      borderRadius: '8px',
    },
  },
  ReviewSummaryReportDetail: {
    '& .MuiTypography-body1': {
      textAlign: 'right',
    },
  },
  ReviewSummaryReportDetailTotal: {
    background: '#f0f1f3',
  },
  FinancialProgressionDateFilter: {
    '& label': {
      fontWeight: '700',
    },
    '& .MuiOutlinedInput-root': {
      border: '1px solid #000',
    },
  },
  vghealthresultsOuter: {
    maxWidth: '20%',
    flexBasis: '20%',
    '@media (max-width:1200px)': {
      maxWidth: '33.33%',
      flexBasis: '33.33%',
    },
    '@media (max-width:960px)': {
      maxWidth: '50%',
      flexBasis: '50%',
    },
    '@media (max-width:640px)': {
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  vghealthresults: {
    border: '2px solid #fff',
    cursor: 'pointer',
    opacity: '0.66',
    height: '99px',
    '@media (max-width:1200px)': {
      height: '100%',
    },
    '&:hover': {
      backgroundColor: '#003C6F',
      color: '#fff',
      border: '2px solid #003C6F',
      '& .MuiTypography-h5': {
        color: '#fff',
      },
      '& .MuiTypography-h2': {
        color: '#fff',
      },
    },
  },
  vghealthresultsSelect: {
    backgroundColor: '#003C6F',
    border: '2px solid #fff',
    borderBottom: '20px solid #fff',
    color: '#fff',
    cursor: 'pointer',
    height: '118px',
    '& .MuiTypography-h5': {
      color: '#fff',
    },
    '& .MuiTypography-h2': {
      color: '#fff',
    },
    '& .MuiSvgIcon-root': {
      color: '#fff',
    },
    '@media (max-width:1200px)': {
      borderBottom: 'none',
    },
  },
  vghealthresultsLast: {
    backgroundColor: '#003C6F',
    border: '4px solid #003C6F',
    cursor: 'pointer',
    height: '99px',
    '@media (max-width:1200px)': {
      height: '100%',
    },
    '& .MuiTypography-h5': {
      color: '#fff',
    },
    '& .MuiTypography-h2': {
      color: '#fff',
      fontSize: '28px',
      marginTop: '-12px',
    },
    '& .MuiSvgIcon-root': {
      color: '#FF3E32',
    },
  },
  vghealthresultsLastSelect: {
    backgroundColor: '#003C6F',
    border: '4px solid #fff',
    borderBottom: '20px solid #fff',
    color: '#fff',
    '& .MuiTypography-h5': {
      color: '#fff',
    },
    '& .MuiTypography-h2': {
      color: '#fff',
      fontSize: '28px',
      marginTop: '-12px',
    },
    '& .MuiSvgIcon-root': {
      color: '#FF3E32',
    },
    '@media (max-width:1200px)': {
      borderBottom: '4px solid #fff',
    },
  },
  surveyResultsDetail: {
    marginTop: '-20px',
    '@media (max-width:1200px)': {
      marginTop: '0',
    },
    '& .MuiOutlinedInput-root': {
      border: '1px solid #000',
    },
  },
  VSRDBtn: {
    padding: '5px 10px',
  },
  surveyresultdetailstable: {
    '& .MuiTableCell-root:last-child': {
      width: '12% !important',
      '& .MuiButton-root': {
        minWidth: '140px',
      },
    },
  },
  reportBox: {
    background: '#F8F9FC',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    minWidth: '140px',
    '& .MuiTypography-h5': {
      fontWeight: '400',
    },
  },
  greendata: {
    background: '#DFF1E8',
    borderRadius: '8px',
    color: '#008A45',
    fontWeight: '700',
    fontSize: '14px',
    '& .MuiSvgIcon-root': {
      fontSize: '22px',
    },
  },
  graydata: {
    background: '#F1F3F9',
    borderRadius: '8px',
    color: 'rgba(0, 0, 0, 0.6)',
    fontWeight: '700',
    fontSize: '14px',
    '& .MuiSvgIcon-root': {
      fontSize: '22px',
    },
  },
  reddata: {
    background: '#FFEBEE',
    borderRadius: '8px',
    color: '#E53451',
    fontWeight: '700',
    fontSize: '14px',
    '& .MuiSvgIcon-root': {
      fontSize: '22px',
    },
  },
  QuarterlyMeetingObjectives: {
    '& .MuiAccordion-root': {
      borderRadius: '0',
      backgroundColor: 'transparent',
      borderBottom: '1px solid #f2f5f8',
      margin: '0',
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      background: '#f0f1f3',
      minHeight: '48px',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '0',
    },
    '& .MuiTypography-h4': {
      marginBottom: '10px',
    },
  },
  QMODetails: {
    fontSize: '13px',
  },
  modalfooterlogo: {
    display: 'flex',
    background: '#E5E5E5',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '2px',
    padding: '6px 8px',
  },

  FilterDropdownWidth: {
    '& .MuiFormControl-root': {
      width: '180px',
    },
  },
  EAFilterDropdownWidth: {
    '& .MuiFormControl-root': {
      width: '160px',
    },
  },
  FilterDropdownWidthSelect: {
    '& .MuiInputBase-input::placeholder': {
      color: '#4e5054',
      opacity: 1, // Required to make color visible in some browsers
    },
    '& .MuiFormControl-root': {
      width: '180px',
    },
    '& .MuiAutocomplete-tag': {
      display: 'none',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: '#4e5054',
      display: 'block',
      fontSize: '13px',
      zIndex: '1',
      transform: 'translate(10px, 7px) scale(1)',
      pointerEvents: 'none',
      fontWeight: '400',
    },
  },

  FilterDropdownWidthSelectMob: {
    '& .MuiInputBase-input::placeholder': {
      color: '#4e5054',
      opacity: 1,
    },
    '& .MuiAutocomplete-tag': {
      display: 'none',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: '#4e5054',
      display: 'block',
      fontSize: '13px',
      zIndex: '1',
      transform: 'translate(10px, 7px) scale(1)',
      pointerEvents: 'none',
      fontWeight: '400',
    },
  },
  materialDTNewStyle: {
    marginTop: '10px',

    '& .MuiPaper-root > div': {
      border: '1px solid #809eb7',
    },

    '& > div': {
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        height: '10px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '5px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    },

    '& .MuiTableRow-root:nth-child(odd)': {
      backgroundColor: '#fff5f5',
    },

    '& .MuiTableCell-head': {
      backgroundColor: '#003C6F !important',
      color: '#fff !important',
      padding: '4px 12px !important',
      '& .MuiButton-root': {
        minWidth: 'auto !important',
        margin: '0 0 0 8px !important',
        padding: '0 !important',
        color: '#fff !important',
        '& .MuiSvgIcon-root': {
          fontSize: '20px !important',
        },
      },
    },

    // Dynamic column widths - removed fixed widths to allow table to fill available space
    // Column widths are now handled by colgroup in the component

    '& .MuiTableCell-root': {
      padding: '8px 12px !important',
    },

    '& .MuiTableCell-body': {
      width: 'auto !important',
      fontSize: '13px !important',
      color: '#0F0F10 !important',
    },

    '& .MuiTableCell-body:nth-child(2)': {
      textDecoration: 'underline !important',
    },

    // Table container with scrollbar
    '& .table-container': {
      overflowX: 'auto !important',
      marginTop: '10px !important',
      border: '1px solid #809eb7 !important',

      '&::-webkit-scrollbar': {
        height: '8px !important',
      },
      '&::-webkit-scrollbar-track': {
        background: '#fff !important',
        borderRadius: '10px !important',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#4b403a66 !important',
        borderRadius: '4px !important',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#4b403a66 !important',
      },
    },

    // Table layout
    '& table': {
      width: '100% !important',
      display: 'table !important',
      tableLayout: 'auto !important',
      borderCollapse: 'separate !important',
      margin: '0 !important',
    },

    '& thead tr td': {
      backgroundColor: '#003C6F !important',
      color: '#fff !important',
      padding: '4px 12px !important',
      border: '1px solid #dee6ec !important',
      textAlign: 'center !important',
      verticalAlign: 'middle !important',
      whiteSpace: 'nowrap !important',
      '& .MuiButton-root': {
        minWidth: 'auto !important',
        minHeight: 'auto !important',
        margin: '0 0 0 8px !important',
        padding: '0 !important',
        color: '#fff !important',
        '& .MuiSvgIcon-root': {
          fontSize: '20px !important',
        },
      },
    },

    '& thead tr td:first-child': {
      textAlign: 'left !important',
    },

    '& tbody tr td, & tfoot tr td': {
      width: 'auto !important',
      padding: '8px 12px !important',
      fontSize: '13px !important',
      color: '#0F0F10 !important',
      cursor: 'pointer !important',
      border: '1px solid #dee6ec !important',
    },

    '& tbody tr td:first-child': {
      textAlign: 'left !important',
    },

    '& tbody tr td:nth-child(2)': {
      textDecoration: 'underline !important',
    },

    '& tbody tr:nth-child(odd)': {
      backgroundColor: '#fff5f5 !important',
    },

    '& tfoot tr td p': {
      color: '#0F0F10 !important',
      fontWeight: 'bold !important',
    },

    '& .RankingNumber': {
      background: '#e5ebf0 !important',
      color: '#003C6F !important',
      borderRadius: '50% !important',
      fontSize: '13px !important',
      fontWeight: '700 !important',
      lineHeight: '20px !important',
      height: '24px !important',
      width: '24px !important',
      display: 'flex !important',
      justifyContent: 'center !important',
      alignItems: 'center !important',
      margin: '0 auto !important',
      textAlign: 'center !important',
    },

    '& .MuiTableFooter-root': {
      border: '1px solid #f2f5f8 !important',
      '& .MuiTableRow-footer': {
        background: '#fff !important',
        '& .MuiTableCell-root': {
          padding: '0 12px !important',
          color: '#91979d !important',
          '& .MuiTablePagination-select': {
            paddingTop: '0 !important',
            paddingBottom: '0 !important',
            width: 'auto !important',
            color: '#91979d !important',
          },
          '& .MuiSelect-nativeInput': {
            width: 'auto !important',
          },
          '& .MuiSelect-icon': {
            position: 'relative !important',
            right: '24px !important',
            color: '#91979d !important',
          },
          '& .MuiIconButton-root': {
            padding: '0 !important',
            margin: '0 8px !important',
          },
          '& .MuiTablePagination-toolbar': {
            minHeight: '36px !important',
            '& .MuiTablePagination-spacer': {
              display: 'none !important',
            },
            '& p.MuiTablePagination-caption': {
              display: 'block !important',
            },
            '& span.MuiTypography-caption': {
              display: 'none !important',
            },
            '& .MuiTablePagination-input': {
              flex: '1 1 100% !important',
            },
          },
        },
      },
    },
  },

  tableFooter: {
    width: '100%',
    marginTop: '10px',
    display: 'flex',
    color: '#91979d',
    justifyContent: 'space-between',
    '& select': {
      border: 'none',
      color: '#91979d',
    },
    '& select:focus': {
      outline: 'none',
    },
    '& .MuiSelect-select': {
      padding: '2px 32px 2px 5px',
      boxShadow: 'none',
      border: 'none',
      color: '#91979d',
      fontSize: '13px',
    },
    '& .MuiSelect-icon': {
      color: '#91979d',
      right: '24px',
      position: 'relative',
    },
  },
  footerArrowSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& button': {
      background: 'none',
      padding: 0,
      border: 'none',
      width: 'auto',
      height: 'auto',
      display: 'flex',
      cursor: 'pointer',
      '& .MuiSvgIcon-root': {
        fontSize: '24px',
        color: '#92979d',
      },
    },
    '& button[disabled]': {
      '& .MuiSvgIcon-root': {
        color: '#00000042',
        cursor: 'default',
      },
    },
  },
  RankingNumber: {
    background: '#e5ebf0',
    color: '#003C6F',
    borderRadius: '50%',
    fontSize: '13px',
    fontWeight: '700',
    lineHeight: '20px',
    height: '24px',
    width: '24px',
    display: 'block',
    margin: '0 auto',
    textAlign: 'center',
  },
  TableInnerFilter: {
    borderRadius: '18px',
    border: '1px solid #C2C9D1',
    background: '#FDFEFF',
    padding: '0 8px',
    '& .MuiButton-outlined': {
      border: 'none !important',
      background: 'transparent',
      fontSize: '13px',
      padding: 0,
      minHeight: 'auto',
    },
    '& .MuiSvgIcon-root': {
      color: '#4E5054',
    },
  },
  TableInnerFilterSelect: {
    borderRadius: '18px',
    border: '2px solid #FF3E32',
    background: '#e5ebf0',
    '& .MuiButton-outlined': {
      border: 'none',
      background: 'transparent',
      fontSize: '13px',
      padding: '6px 10px',
      minHeight: 'auto',
      fontWeight: '700',
    },
    '& .MuiButton-outlined:nth-child(2)': {
      padding: '0 4px 0 0',
    },
    '& .MuiSvgIcon-root': {
      color: '#4E5054',
    },
  },
  ThreeDotSearch: {
    borderRadius: '3px',
    border: '1px solid #C2C9D1',
    background: '#FDFEFF',
    height: '24px',
    width: '24px',
    display: 'block',
    float: 'right',
    textAlign: 'center',
    padding: '2.5px 0',
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
      color: '#616468',
    },
  },
  EmployeeAnalysisTabs: {
    '& .MuiTabs-root': {
      minHeight: 'auto',
    },
    '& .MuiTab-root': {
      padding: '0 16px',
      textTransform: 'capitalize',
      color: '#003C6F !important',
      opacity: 1,
      margin: '0 0 -3px 0',
    },
    '& .Mui-selected': {
      backgroundColor: '#e5ebf1',
      color: '#003C6F !important',
      borderRadius: '4px',
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  SmallDialog: {
    '& .MuiPaper-root': {
      width: '325px',
    },
    '& .MuiDialogTitle-root': {
      textAlign: 'left',
    },
    '& .MuiDialogActions-spacing': {
      justifyContent: 'center',
    },
  },
  MoreOptionsV2: {
    '& .MuiList-root': {
      margin: 0,
    },
    '& .MuiListItem-button': {
      color: '#0F0F10',
      '&:hover': {
        backgroundColor: '#f2f5f8',
        color: '#003C6F',
      },
    },
  },
  /* RankingDetailTop: {
    lineHeight: '16px',
    marginBottom: '-5px',
    marginTop: '5px',
  }, */
  TableSortIcon: {
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
  },
  TableSortIconClicked: {
    '& .MuiSvgIcon-root': {
      transform: 'rotate(180deg)',
    },
  },
  CollectionsReportSectionHeading: {
    color: '#4E5054',
  },
  CollectionsReportRedText: {
    color: '#bf2e25',
    fontWeight: '400',
  },
  CollectionsReportGreenText: {
    color: '#1e601d',
    fontWeight: '400',
  },
  CollectionsReportBlackText: {
    color: '#313234',
    fontWeight: '700',
  },
  CollectionsReportDueBalance: {
    color: '#616468',
    marginLeft: '8px',
  },
  TableUIV2: {
    '& .MuiTableCell-root': {
      wordBreak: 'normal',
    },
    '& .MuiTableCell-head:nth-child(3)': {
      '& .MuiTableSortLabel-root': {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        lineHeight: '16px',
      },
    },
    '& .MuiTableCell-head:nth-child(4)': {
      '& .MuiTableSortLabel-root': {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        lineHeight: '16px',
      },
    },
    '& .MuiTableCell-head:nth-child(5)': {
      '& .MuiTableSortLabel-root': {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        lineHeight: '16px',
      },
    },
  },
  TableUIV3: {
    '& .MuiTableCell-root': {
      wordBreak: 'normal',
      position: 'relative',
    },
    '& .MuiTableCell-body:nth-child(1)': {
      padding: '0',
      '& div': {
        '& span': {
          padding: '13px',
          display: 'flex',
        },
      },
    },
    '& .MuiTableCell-head:nth-child(3)': {
      '& .MuiTableSortLabel-root': {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        lineHeight: '16px',
      },
    },
    '& .MuiTableCell-head:nth-child(4)': {
      '& .MuiTableSortLabel-root': {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        lineHeight: '16px',
      },
    },
    '& .MuiTableCell-head:nth-child(5)': {
      '& .MuiTableSortLabel-root': {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        lineHeight: '16px',
      },
    },
  },
  TableTextRed: {
    color: '#BF2E25',
  },
  vectorranking: {
    background: '#e5ebf0',
    color: '#003C6F',
    borderRadius: '18px',
    fontSize: '13px',
    fontWeight: '700',
    lineHeight: '20px',
    height: '24px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  vectorRankingGreen: {
    background: '#ceefce',
    color: '#1e601d',
    borderRadius: '18px',
    fontSize: '13px',
    fontWeight: '700',
    lineHeight: '20px',
    height: '24px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  vectorRankingBlue: {
    background: '#003C6F',
    color: '#003C6F',
    borderRadius: '18px',
    fontSize: '13px',
    fontWeight: '700',
    lineHeight: '20px',
    height: '24px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  vectorRankingRed: {
    background: '#ffebea',
    color: '#bf2e25',
    borderRadius: '18px',
    fontSize: '13px',
    fontWeight: '700',
    lineHeight: '20px',
    height: '24px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  vectorRankingGrey: {
    background: '#D9D9D9',
    color: '#2B2B2B',
    borderRadius: '18px',
    fontSize: '13px',
    fontWeight: '700',
    lineHeight: '20px',
    height: '24px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  goalModelDialog: {
    '&.MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
  },
  AnnouncementText: {
    fontSize: '13px',
    color: '#616569',
  },
  TableTooltipBoxText: {
    '& .MuiPaper-root': {
      padding: theme.spacing(1),
      background: '#616468',
      width: '225px',
      '& .MuiTypography-root': {
        color: '#fff',
      },
    },
    overflow: 'auto',
  },
  LastEditBox: {
    '& .MuiTypography-root': {
      color: '#C2C9D1',
    },
    '& .MuiSvgIcon-root': {
      color: '#DAEBF5',
      fontSize: '20px',
      cursor: 'pointer',
    },
  },
  InfoAlertBox: {
    background: '#e5ebf0',
    border: '1px solid #dee6ec',
    '& .MuiAlert-icon': {
      '& .MuiSvgIcon-root': {
        color: '#003C6F',
      },
    },
    '& .MuiAlert-message': {
      color: '#0F0F10',
      fontSize: '13px',
    },
    '& .MuiIconButton-label': {
      '& .MuiSvgIcon-root': {
        color: '#878787',
      },
    },
  },
  SuccessAlertBox: {
    background: '#ebf9eb',
    border: '1px solid #ceefce',
    '& .MuiAlert-icon': {
      '& .MuiSvgIcon-root': {
        color: '#3CC13B',
      },
    },
    '& .MuiAlert-message': {
      color: '#0F0F10',
      fontSize: '13px',
    },
    '& .MuiIconButton-label': {
      '& .MuiSvgIcon-root': {
        color: '#878787',
      },
    },
  },
  DangerAlertBox: {
    background: '#fdebeb',
    border: '1px solid #fbcdcd',
    '& .MuiAlert-icon': {
      '& .MuiSvgIcon-root': {
        color: '#F03738',
      },
    },
    '& .MuiAlert-message': {
      color: '#0F0F10',
      fontSize: '13px',
    },
    '& .MuiIconButton-label': {
      '& .MuiSvgIcon-root': {
        color: '#878787',
      },
    },
  },
  TooltipEditorOuter: {
    display: 'none',
  },
  TooltipEditor: {
    '& .sun-editor': {
      background: 'transparent',
      borderRadius: '8px',
      overflow: 'hidden',
      '& .se-toolbar': {
        background: '#4E5054',
        '& .se-btn': {
          '& svg': {
            color: '#fff',
          },
          '&:hover': {
            background: '#fff',
            '& svg': {
              color: '#000',
            },
          },
        },
      },
      '& .se-placeholder': {
        display: 'none !important',
      },
      '& .sun-editor-editable': {
        background: 'transparent',
        padding: '8px',
        '& p': {
          color: '#FDFEFF',
          fontFamily: 'Lato',
          fontSize: '13px',
          fontWeight: '400',
          lineHeight: '20px',
        },
      },
      '& .se-resizing-bar': {
        display: 'none',
      },
    },
  },
  TooltipEditorBtnCancel: {
    minWidth: 'auto',
    color: '#DAEBF5',
    fontSize: '11px',
    fontWeight: '700',
  },
  TooltipEditorBtnSave: {
    minWidth: 'auto',
    background: '#DAEBF5',
    color: '#616468',
    fontSize: '11px',
    fontWeight: '700',
    '&:hover': {
      background: '#DAEBF5',
      color: '#616468',
    },
  },
  WarningCirleBox: {
    background: '#fef6e8',
    height: '28px',
    width: '28px',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiSvgIcon-root': {
      color: '#FD8E39',
      fontSize: '16px',
    },
  },
  DataImportOuter: {
    '& .MuiTypography-body1': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  GraphDetailBox: {
    border: '1px solid #dee6ec',
    borderRadius: '4px',
  },
  CompanyOperationalPerformanceFilter: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiSelect-selectMenu': {
      padding: '8px 24px 8px 10px',
      borderRadius: '4px',
    },
  },
  GraphToggle: {
    '& .MuiToggleButton-root': {
      background: '#fff',
      color: 'rgba(0, 60, 111, 1)',
      padding: '5px 15px',
      borderRadius: '8px',
      border: '1px solid rgba(0, 60, 111, 1)',
    },
    '& .MuiToggleButton-root.Mui-selected': {
      background: 'rgba(0, 60, 111, 1)',
      color: '#fff !important',
      '& svg path': {
        fill: '#fff',
      },
    },
    '& .MuiToggleButtonGroup-groupedHorizontal:not(:last-child)': {
      borderTopRightRadius: '0',
      borderBottomRightRadius: '0',
    },
    '& .MuiToggleButtonGroup-groupedHorizontal:not(:first-child)': {
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0',
      borderLeft: '1px solid transparent',
    },
  },
  TooltipCancelBtn: {
    '& .MuiButtonBase-root': {
      minWidth: '65px',
      color: '#DAEBF5',
      padding: '8px 16px',
      fontWeight: '700',
    },
  },
  TooltipSaveBtn: {
    '& .MuiButtonBase-root': {
      minWidth: '55px',
      background: '#DAEBF5',
      color: '#616569',
      padding: '8px 16px',
      fontWeight: '700',
    },
  },
  TooltipEditedDate: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiTypography-root': {
      color: '#e1e4e8',
      fontStyle: 'italic',
    },
    '& .MuiSvgIcon-root': {
      color: '#DAEBF5',
      cursor: 'pointer',
    },
  },
  TableLightText: {
    color: 'rgba(0, 0, 0, 0.6)',
    marginLeft: '3px',
  },
  WorkLoadDropdownOutline: {
    '& .MuiSelect-select': {
      borderRadius: '4px',
      boxShadow: 'none',
      border: '1px solid #e1e4e8',
      padding: '10px 25px 10px 14px',
      fontSize: '13px',
      fontWeight: '400',
    },
  },
  WorkLoadDropdownCheckbox: {
    height: '40px',
    padding: '10px 5px',
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: '#003C6F',
    },
    '& .MuiListItemText-primary': {
      fontWeight: '400',
    },
  },
  TableIconText: {
    cursor: 'pointer',
    '& .MuiTypography-body1': {
      color: '#003C6F',
      borderBottom: '1px solid #003C6F',
    },
  },
  innercontentcolor1: {
    backgroundColor: '#003C6F',
    borderRadius: '4px',
    padding: 16,
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
    '& .MuiTypography-root': {
      color: '#fff',
    },
    '& .MuiTypography-h2': {
      fontWeight: '400',
    },
  },
  innercontentcolor2: {
    backgroundColor: '#0F6E8C',
    borderRadius: '4px',
    padding: 16,
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
    '& .MuiTypography-root': {
      color: '#fff',
    },
    '& .MuiTypography-h2': {
      fontWeight: '400',
    },
  },
  innercontentDefaultcolor: {
    backgroundColor: '#f7f9fa',
    borderRadius: '4px',
    padding: 16,
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
    '& .MuiTypography-h2': {
      fontWeight: '400',
    },
  },
  CellScrollBox: {
    flexWrap: 'nowrap',
    overflowX: 'scroll',
    '& .MuiGrid-item': {
      minWidth: '170px',
    },
    '&::-webkit-scrollbar': {
      height: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#555',
    },
  },

  autoCompleteOption: {
    backgroundColor: '#fff !important',
    '&:hover': {
      backgroundColor: `${theme.palette.action.hover} !important`,
    },
  },

  CellWorkRankingNA: {
    background: 'rgba(255, 255, 255, 0.9)',
    color: 'rgba(97, 101, 105, 1) !important',
    borderRadius: '18px',
    fontSize: '13px',
    fontWeight: '700 !important',
    lineHeight: '20px',
    height: '24px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  CellWorkRankingGreen: {
    background: '#ceefce',
    color: '#1e601d !important',
    borderRadius: '18px',
    fontSize: '13px',
    fontWeight: '700 !important',
    lineHeight: '20px',
    height: '24px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  CellWorkRankingBlue: {
    background: '#e5ebf0',
    color: '#003C6F !important',
    borderRadius: '18px',
    fontSize: '13px',
    fontWeight: '700 !important',
    lineHeight: '20px',
    height: '24px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  popover: {
    pointerEvents: 'none',
  },
  popOverPaper: {
    padding: theme.spacing(1),
    background: '#616468',
    width: '200px',
    overflowX: 'unset',
    overflowY: 'unset',
    '& .MuiTypography-root': {
      color: '#fff',
    },
  },
  InfoIconStyle: {
    color: '#91979D',
    '&:hover': {
      color: '#616569',
    },
  },
  myChartContainer: {
    backgroundColor: '#3CC13B',
  },
  TableCheckBox: {
    '& .MuiFormControlLabel-root': {
      marginRight: '0',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
  TableCheckBoxClicked: {
    backgroundColor: '#e2ddd8',
  },
  SelectCountryBox: {},
  activeTab: {
    borderBottom: '4px solid #ff3e32',
  },
  ClientComplexityScore: {
    '& .MuiTableCell-head': {
      whiteSpace: 'normal',
      lineHeight: '14px',
    },
    '& .MuiTableCell-head:nth-child(1)': {
      zIndex: '3 !important',
      left: '0px !important',
    },
    '& .MuiTable-root': {
      display: 'block',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    },
    '& .MuiTableCell-root:last-child': {
      width: '120px !important',
    },
  },
  RedWarningIcon: {
    '& .MuiSvgIcon-root': {
      color: '#F03738',
      fontSize: '20px',
    },
  },
  EmployeeInformationBlock: {
    '& .MuiTypography-subtitle1': {
      lineHeight: '16px',
    },
    '& .MuiTypography-body1': {
      paddingLeft: '20px',
    },
  },
  EmployeeInformationBlockPhoto: {
    height: '80px',
    width: '80px',
    border: '1px solid #000',
    borderRadius: '5px',
    overflow: 'hidden',
    position: 'relative',
    '&:hover': {
      '& .MuiIconButton-root': {
        display: 'block',
      },
    },
    '& .MuiIconButton-root': {
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: '5px',
      display: 'none',
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  },

  // MaterialTable styles for Employee Directory with dynamic column widths
  materialDT: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid #dee6ec',
    },

    '& .MuiTableCell-head': {
      backgroundColor: '#003C6F !important',
      color: '#fff !important',
      padding: '8px 12px !important',
      fontSize: '14px !important',
      fontWeight: '600 !important',
      '& .MuiButton-root': {
        minWidth: 'auto !important',
        margin: '0 0 0 8px !important',
        padding: '0 !important',
        color: '#fff !important',
        '& .MuiSvgIcon-root': {
          fontSize: '18px !important',
        },
      },
    },

    '& .MuiTableCell-body': {
      padding: '8px 12px !important',
      fontSize: '13px !important',
      color: '#4e5054 !important',
      borderBottom: '1px solid #dee6ec !important',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '& table': {
      width: '100% !important',
      tableLayout: 'auto !important', // Enable dynamic column sizing
    },

    // Remove excessive padding and optimize spacing
    '& .MuiTableRow-root': {
      '& .MuiTableCell-body:nth-child(1)': {
        '& a': {
          textDecoration: 'underline',
          color: '#003C6F',
        },
      },
    },
  },
}));

export default useStyles;
